import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MortgageIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M7.2 45.5c-.6 0-1-.4-1-1V22.8c0-.3.1-.6.4-.8L24.4 8.2c.2-.2.4-.2.6-.2.2 0 .4.1.6.2l17.8 14.4c.2.2.4.5.4.8v21.2c0 .6-.4 1-1 1H7.2z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m25 9 17.8 14.4v21.2H7.2V22.8L25 9m0-2c-.4 0-.9.1-1.2.4L6 21.2c-.5.4-.8 1-.8 1.6v21.7c0 1.1.9 2 2 2h35.5c1.1 0 2-.9 2-2V23.3c0-.6-.3-1.2-.7-1.6L26.3 7.4c-.4-.3-.8-.4-1.3-.4z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M45.7 26.8c-.2 0-.5-.1-.6-.2L25 10 4.4 26.6c-.2.1-.4.2-.6.2h-.1c-.3 0-.5-.2-.7-.4l-2-2.5c-.3-.4-.3-1.1.2-1.4L24.4 3.8c.2-.1.4-.2.6-.2.2 0 .5.1.6.2l22.7 18.8c.4.4.5 1 .1 1.4l-2 2.4c-.1.3-.4.4-.7.4z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m25 4.6 22.7 18.8-2 2.4L25 8.7 3.7 25.8l-2-2.5L25 4.6m0-2c-.4 0-.9.1-1.3.4L.5 21.7c-.9.7-1 2-.3 2.8l2 2.5c.3.4.8.7 1.3.7h.2c.5 0 .9-.2 1.3-.4l20-16.1 19.4 16.1c.4.3.8.5 1.3.5.6 0 1.1-.2 1.5-.7l2-2.4c.3-.4.5-.9.5-1.5s-.3-1-.7-1.4L26.3 3.1c-.4-.4-.8-.5-1.3-.5z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="m15.3 10.1-5.7 5v-10h5.7z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M27 41.1h-9.4v-3.9c1.6 0 2.5-1 2.5-2.7 0-.4 0-.7-.1-1.1h-2.3v-2.6h1.4c-.5-1.1-1-2.2-1-3.8 0-3.7 2.8-6.4 6.8-6.4 4.2 0 6.3 2.7 6.3 5.9 0 1.4-.4 2.5-1 3.4l-3.8-1.5c.3-.5.5-1 .5-1.7 0-1.3-.8-2.3-2-2.3-1.4 0-2.2 1.1-2.2 2.7 0 1.5.5 2.6 1 3.7h3.1v2.6h-2.5v.5c0 1.4-1.1 2.7-2.2 3.3h4.3c1.8 0 2.7-.8 2.9-2.6l2.9 2.5c-.4 2.8-2.2 4-5.2 4"
        fill="#E81C30"
        className={styles.accentColor}
      />
    </Icon>
  )
}
